import { Injectable } from '@angular/core';
import { InMemoryDbService } from 'angular-in-memory-web-api';

// Do not remove or change this file. The app-in-memory-data.services.ts will be replaced with this file for production environments.
@Injectable({
  providedIn: 'root',
})
export class AppInMemoryDataService implements InMemoryDbService {

  createDb() {
    return {}
  }
}
